import { useQuery } from '@tanstack/react-query';

import { companiesService, Company } from '@aslanpay/portal-common-lib';

const useFetchCompany = (id?: string) => {
  return useQuery<Company, Error>(
    ['fetchCompany', id],
    () => companiesService.fetchCompany(id || ''),
    {
      enabled: !!id,
    }
  );
};

export default useFetchCompany;
